import { useQueryString } from '@frx/frx-react-context';

export const useEventId = (): number => {
  const { queryStrings } = useQueryString();
  const eventId = queryStrings.fr_id
    ? parseInt(queryStrings.fr_id as string)
    : 0;
  return eventId;
};
